var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 29,
    viewBox: "0 0 24 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.24286 1.00254C7.53214 0.385156 8.12679 0 8.775 0H15.225C15.8732 0 16.4679 0.385156 16.7571 1.00254L17.1429 1.8125H22.2857C23.2339 1.8125 24 2.62246 24 3.625C24 4.62754 23.2339 5.4375 22.2857 5.4375H1.71429C0.766071 5.4375 0 4.62754 0 3.625C0 2.62246 0.766071 1.8125 1.71429 1.8125H6.85714L7.24286 1.00254ZM1.71429 7.25H22.2857V25.375C22.2857 27.3744 20.7482 29 18.8571 29H5.14286C3.25179 29 1.71429 27.3744 1.71429 25.375V7.25ZM6.85714 10.875C6.38571 10.875 6 11.2828 6 11.7812V24.4688C6 24.9672 6.38571 25.375 6.85714 25.375C7.32857 25.375 7.71429 24.9672 7.71429 24.4688V11.7812C7.71429 11.2828 7.32857 10.875 6.85714 10.875ZM12 10.875C11.5286 10.875 11.1429 11.2828 11.1429 11.7812V24.4688C11.1429 24.9672 11.5286 25.375 12 25.375C12.4714 25.375 12.8571 24.9672 12.8571 24.4688V11.7812C12.8571 11.2828 12.4714 10.875 12 10.875ZM17.1429 10.875C16.6714 10.875 16.2857 11.2828 16.2857 11.7812V24.4688C16.2857 24.9672 16.6714 25.375 17.1429 25.375C17.6143 25.375 18 24.9672 18 24.4688V11.7812C18 11.2828 17.6143 10.875 17.1429 10.875Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/trash.89a430c84a9f8821c8405a0e6545d81c.svg";
export { ForwardRef as ReactComponent };